import { ChangeDetectorRef, Component } from '@angular/core';
import { fadeInAnimation, fadeOutAnimation } from 'angular-animations';
import { Constants } from '../../constants';

@Component({
  selector: 'app-background',
  templateUrl: './background.component.html',
  styleUrl: './background.component.scss',
  standalone: false,
  animations: [
    fadeInAnimation({ anchor: 'enter', duration: 1000, delay: 0 }),
    fadeOutAnimation({ anchor: 'leave', duration: 1000, delay: 0 })
  ]
})
export class BackgroundComponent {
  animationStateIn = false;
  animationStateOut = false;
  currentImage: string = "";
  public defaultImage: string = Constants.Images.DefaultNews;
  private newImage: string = "";

  constructor( private ref: ChangeDetectorRef) { 
  }

  public setInitialValue(img: string) {
    this.currentImage = img;
  }

  public changeValue(img: string) {
    this.newImage = img;
    this.animationStateOut = true;
    this.ref.detectChanges();
  }

  public animOutDone() {
      this.currentImage = this.newImage;
      this.animationStateOut = false;
      this.animationStateIn = true;
      this.ref.detectChanges();
  }

  public animInDone() {
    this.animationStateIn = false;
  }

  chargeCanvas()
  {
    if( this.currentImage ) {
      const image = document.getElementById('backgroundImage')  as HTMLImageElement;
      const canvas = document.getElementById('backgroundCanvas') as HTMLCanvasElement;
      const ctx = canvas?.getContext("2d");
      const hRatio = canvas.width / image.width;
    const vRatio = canvas.height / image.height;
    const ratio = Math.max(hRatio, vRatio);

    const centerShiftX = (canvas.width - image.width * ratio) / 2;
    const centerShiftY = (canvas.height - image.height * ratio) / 2;

    ctx?.clearRect(0, 0, canvas.width, canvas.height);
    ctx?.drawImage(image, 0, 0, image.width, image.height, centerShiftX, centerShiftY, image.width * ratio, image.height * ratio);
    }
  }
}
